import { takeLatest, put, call } from 'redux-saga/effects';

import { listCertificadoDigitalCadastro } from '../service';
import {
  TABLE_CERTIFICADO_DIGITAL_CADASTRO,
  TABLE_CERTIFICADO_DIGITAL_CADASTRO_PENDING,
  TABLE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS,
  TABLE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListCertificadoDigitalCadastro(action) {
  yield put({ type: TABLE_CERTIFICADO_DIGITAL_CADASTRO_PENDING })

  try {
    const table = yield call(listCertificadoDigitalCadastro, action.args)
    yield put({ type: TABLE_CERTIFICADO_DIGITAL_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_CERTIFICADO_DIGITAL_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListCertificadoDigitalCadastro() {
  yield takeLatest(TABLE_CERTIFICADO_DIGITAL_CADASTRO, sagaListCertificadoDigitalCadastro)
}